// extracted by mini-css-extract-plugin
export default {"root":"OrderProcessing_root__-pvIM"};